import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import ComplianceAnalysis from "./ComplianceAnalysis";
import OrgComplianceTasksList from "./OrgComplianceTasksList";

const SUB_TABS = [
  { key: "tasks", label: "Tasks" },
  { key: "analysis", label: "Analysis" },
];

const OrgComplianceTasks = ({ orgAdminId }) => {
  const [activeTab, setActiveTab] = useState("tasks");
  const resolvedOrgAdminId = useMemo(() => orgAdminId || null, [orgAdminId]);

  return (
    <section className="space-y-4 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
      <header className="flex flex-col gap-2 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.2rem] text-gray-500">
            OrgAdmin Compliance Tasks
          </p>
          <h3 className="text-2xl font-semibold text-gray-900">
            Compliance Tasks
          </h3>
          <p className="text-sm text-gray-600">
            Prioritized queue of obligations across your assigned corporates and
            companies.
          </p>
        </div>
        <nav className="flex gap-2 rounded-full bg-gray-100 p-1 text-sm font-semibold">
          {SUB_TABS.map((tab) => {
            const isActive = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                className={`rounded-full px-4 py-1.5 transition focus:outline-none focus:ring-2 focus:ring-sflPrimary/50 focus:ring-offset-1 ${
                  isActive
                    ? "bg-white text-sflPrimary shadow"
                    : "text-gray-600 hover:text-sflPrimary"
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </header>

      {activeTab === "tasks" && (
        <OrgComplianceTasksList orgAdminId={resolvedOrgAdminId} />
      )}

      {activeTab === "analysis" && (
        <ComplianceAnalysis scope="orgAdmin" scopeId={resolvedOrgAdminId} />
      )}
    </section>
  );
};

OrgComplianceTasks.propTypes = {
  orgAdminId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

OrgComplianceTasks.defaultProps = {
  orgAdminId: null,
};

export default OrgComplianceTasks;
